<template>
  <div class="p-input-color">
    <button
      type="button"
      class="p-input-color__swatch"
      :style="swatchStyle"
      aria-label="カラーピッカーを開く"
      @click="togglePicker"
    >
      <span class="p-input-color__swatch-color" :style="{ background: value || 'transparent' }"></span>
    </button>
    <input
      type="text"
      class="p-input-color__field"
      :value="value"
      :placeholder="placeholder"
      :style="fieldStyle"
      readonly
      @click="togglePicker"
    />
    <div v-if="isPickerOpen" class="p-input-color__picker-wrapper" :style="pickerStyle">
      <chrome-picker :model-value="pickerValue" @update:model-value="onPickerInput" />
    </div>
  </div>
</template>

<script>
import { Chrome } from '@ckpack/vue-color';

export default {
  components: { 'chrome-picker': Chrome },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    width: { type: [Number, String], default: 100 },
    height: { type: [Number, String], default: 32 },
  },
  emits: ['input'],
  data() {
    return {
      isPickerOpen: false,
      pickerPos: { top: 0, left: 0 },
    };
  },
  computed: {
    fieldStyle() {
      return {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
        height: typeof this.height === 'number' ? `${this.height}px` : this.height,
      };
    },
    swatchStyle() {
      return {
        height: typeof this.height === 'number' ? `${this.height}px` : this.height,
        width: typeof this.height === 'number' ? `${this.height}px` : this.height,
      };
    },
    pickerValue() {
      return this.value || '#ffffff';
    },
    pickerStyle() {
      return {
        top: `${this.pickerPos.top}px`,
        left: `${this.pickerPos.left}px`,
      };
    },
  },
  watch: {
    isPickerOpen(newVal) {
      if (newVal) {
        document.addEventListener('mousedown', this.onOutsideClick);
        // モーダル内のスクロールで位置がずれるのを避けるため、スクロール検知で閉じる
        window.addEventListener('scroll', this.closePicker, true);
        window.addEventListener('resize', this.closePicker);
      } else {
        document.removeEventListener('mousedown', this.onOutsideClick);
        window.removeEventListener('scroll', this.closePicker, true);
        window.removeEventListener('resize', this.closePicker);
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.onOutsideClick);
    window.removeEventListener('scroll', this.closePicker, true);
    window.removeEventListener('resize', this.closePicker);
  },
  methods: {
    togglePicker() {
      if (!this.isPickerOpen) {
        this.updatePickerPosition();
      }
      this.isPickerOpen = !this.isPickerOpen;
    },
    updatePickerPosition() {
      const rect = this.$el.getBoundingClientRect();
      this.pickerPos = {
        top: rect.bottom + 4,
        left: rect.left,
      };
    },
    closePicker() {
      this.isPickerOpen = false;
    },
    onOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.closePicker();
      }
    },
    onPickerInput(color) {
      // vue-color の Chrome ピッカーは { hex, hex8, rgba, hsl, hsv, a } を返す
      // α が 1 未満なら rgba() で出力、それ以外は HEX で出力
      if (color.rgba && color.rgba.a !== undefined && color.rgba.a < 1) {
        const { r, g, b, a } = color.rgba;
        this.$emit('input', `rgba(${r}, ${g}, ${b}, ${a})`);
      } else {
        this.$emit('input', color.hex);
      }
    },
  },
};
</script>

<style scoped>
.p-input-color {
    display: inline-flex;
    align-items: stretch;
    position: relative;
}
.p-input-color__swatch {
    box-sizing: border-box;
    flex: 0 0 auto;
    padding: 0;
    border: 1px solid #ccc;
    border-right: none;
    border-radius: 4px 0 0 4px;
    background: #fff;
    cursor: pointer;
    /* 透過チェッカー柄(色レイヤーは内側の .p-input-color__swatch-color に分離) */
    background-image:
        linear-gradient(45deg, #ccc 25%, transparent 25%),
        linear-gradient(-45deg, #ccc 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #ccc 75%),
        linear-gradient(-45deg, transparent 75%, #ccc 75%);
    background-size: 8px 8px;
    background-position: 0 0, 0 4px, 4px -4px, -4px 0;
}
.p-input-color__swatch-color {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 3px 0 0 3px;
}
.p-input-color__field {
    box-sizing: border-box;
    padding: 0 8px;
    border: 1px solid #ccc;
    border-radius: 0 4px 4px 0;
    font-size: 13px;
    background: #fff;
    cursor: pointer;
}
.p-input-color__picker-wrapper {
    position: fixed;
    z-index: 10010;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
}
</style>
